<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_729_46604)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 2.66675C5.94993 2.66675 2.66669 5.94999 2.66669 10.0001C2.66669 14.0502 5.94993 17.3334 10 17.3334C14.0501 17.3334 17.3334 14.0502 17.3334 10.0001C17.3334 5.94999 14.0501 2.66675 10 2.66675ZM0.666687 10.0001C0.666687 4.84542 4.84536 0.666748 10 0.666748C15.1547 0.666748 19.3334 4.84542 19.3334 10.0001C19.3334 15.1547 15.1547 19.3334 10 19.3334C4.84536 19.3334 0.666687 15.1547 0.666687 10.0001ZM10 4.00008C10.5523 4.00008 11 4.4478 11 5.00008V9.38205L13.7806 10.7723C14.2745 11.0193 14.4748 11.62 14.2278 12.114C13.9808 12.6079 13.3801 12.8082 12.8861 12.5612L9.55281 10.8945C9.21402 10.7251 9.00002 10.3789 9.00002 10.0001V5.00008C9.00002 4.4478 9.44774 4.00008 10 4.00008Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_729_46604">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>
